/**
 * Resolve shipping / returns copy for product detail accordions.
 */

/** @param {object} product */
export function productPdpShippingNote(product, storeCopy = {}) {
  const custom = String(product?.pdp_shipping_note || '').trim();
  if (custom) return custom;
  return String(storeCopy.pdp_shipping_note || storeCopy.trust_badge_1 || 'Ships across India').trim();
}

/** @param {object} product */
export function productPdpReturnsNote(product, storeCopy = {}) {
  const custom = String(product?.pdp_returns_note || '').trim();
  if (custom) return custom;
  const allowance = String(product?.return_allowance || 'inherit').trim();
  if (allowance === 'non_returnable') {
    return 'This piece is non-returnable — handcrafted and made to order.';
  }
  return String(
    storeCopy.pdp_returns_note || 'Handcrafted pieces — see our return policy for eligible items.'
  ).trim();
}
